import CoreApi from 'common/user_activity/core-api';
import { UserActivitySettingsResponse } from './types';
import { call, put } from 'redux-saga/effects';

export function loadUserActivitySettings(
  success: any,
  failure: any,
  default_payload: UserActivitySettingsResponse
): (success: any, failure: any, default_payload: UserActivitySettingsResponse) => Generator {
  return function* () {
    try {
      const settings = yield call(CoreApi.getSettings);
      if (settings.error) {
        if (settings.error.response.status == 404) {
          yield put(success(default_payload));
        } else {
          throw settings.error;
        }
      } else {
        yield put(success(settings));
      }
    } catch (error) {
      console.warn('Unable to load user activity state.', error);
      yield put(failure(error));
    }
  };
}
